import { Injectable } from '@angular/core'
import {
  ModalResponse,
  NgModalServiceInterface,
} from '../../models/modal.model'
import { NgNotificationServiceInterface } from '../../models/notification.model'
import {
  BrandModalCode,
  BrandNotificationCode,
  parseBrandModal,
  parseBrandNotification,
} from './libs/brand-notification.lib'
import { Brand } from './models/brand.entity'

@Injectable({
  providedIn: 'root',
})
export class BrandsRepository {
  constructor(
    private ngModalService?: NgModalServiceInterface,
    private ngNotificationService?: NgNotificationServiceInterface,
  ) {}

  notify(options: { code?: BrandNotificationCode; message?: string }): void {
    this.ngNotificationService?.show(
      options.message
        ? { title: 'Error', message: options.message, color: 'error' }
        : parseBrandNotification(options.code),
    )
  }

  async alert(code: BrandModalCode, brand?: Brand): Promise<ModalResponse> {
    const settings = parseBrandModal(code, brand)
    if (!this.ngModalService || !settings) {
      return 'closed'
    }
    return await this.ngModalService.showDialog(settings)
  }
}
